/** 经联社相关接口 */
import { $post, $download } from '@/api/request'

// 生产队列表查询
export function teamQuery (data = {}) {
  return $post({
    url: '/euProductionTeamInfo/query',
    data
  })
}
// 生产队批量新增
export function teamBatchAdd (data = {}) {
  return $post({
    url: '/euProductionTeamInfo/batchAdd',
    data
  })
}
// 生产队更新
export function teamUpdate (data = {}) {
  return $post({
    url: '/euProductionTeamInfo/update',
    data
  })
}
// 人员信息列表查询
export function euFarmerInfoQuery (data = {}) {
  return $post({
    url: '/euFarmerInfo/listByPage',
    data
  })
}
// 人员信息新增 euFarmerInfo
export function euFarmerInfoAdd (data = {}) {
  return $post({
    url: '/euFarmerInfo/add',
    data
  })
}
// 人员信息修改 euFarmerInfo
export function euFarmerInfoUpdate (data = {}) {
  return $post({
    url: '/euFarmerInfo/update',
    data
  })
}
// 人员信息导出
export function euFarmerInfoExport (data = {}) {
  return $download({
    url: '/euFarmerInfo/export',
    responseType: 'blob',
    data
  })
}
// 列表查询农龄待审核
export function listAgeWaitApproval (data = {}) {
  return $post({
    url: '/euFarmerAge/listAgeWaitApproval',
    data
  })
}
// 农龄管理-提交审核
export function euFarmerAgeSubmit (data = {}) {
  return $post({
    url: '/euFarmerAge/submit',
    data
  })
}
// 查看农龄详情1
export function euFarmerAgeGetDetail (data = {}) {
  return $post({
    url: '/euFarmerAge/getDetail',
    data
  })
}
// 查看农龄详情
export function euFarmerAgeGetDetailForIndex (data = {}) {
  return $post({
    url: '/euFarmerAge/getDetailForIndex',
    data
  })
}
// 农龄审核
export function euFarmerAgeAudit (data = {}) {
  return $post({
    url: '/euFarmerAge/audit',
    data
  })
}
// 成员汇总-分页查询
export function summaryListByPage (data = {}) {
  return $post({
    url: '/euFarmerInfo/summary/listByPage',
    data
  })
}
// 成员汇总-导出
export function farmerExport (data = {}) {
  return $download({
    url: '/euFarmerInfo/farmer/export',
    data
  })
}
// 份额管理-提交审核
export function euFarmerStockSubmit (data = {}) {
  return $post({
    url: '/euFarmerStock/submit',
    data
  })
}
// 份额管理-份额详情
export function euFarmerStockGetDetail (data = {}) {
  return $post({
    url: '/euFarmerStock/getDetail',
    data
  })
}
// 份额管理-待审核列表
export function listStockWaitApproval (data = {}) {
  return $post({
    url: '/euFarmerStock/listStockWaitApproval',
    data
  })
}
// 份额管理-审核
export function euFarmerStockAudit (data = {}) {
  return $post({
    url: '/euFarmerStock/audit',
    data
  })
}
// 份额管理-导出
export function stockExport (data = {}) {
  return $download({
    url: '/euFarmerInfo/stock/export',
    data
  })
}
// 基础信息(euFarmerInfo) 农龄信息(euFarmerAgeHeritage) 份额(euFarmerStockHeritage)导入
export function batchImport (type, data = {}) {
  return $post({
    url: `/${type}/batchImport`,
    data
  })
}
// 查询农龄可被继承人员
export function listAgeInherited (data = {}) {
  return $post({
    url: '/euFarmerInfo/listAgeInherited',
    data
  })
}
// 查询份额可被继承人员
export function listStockInherited (data = {}) {
  return $post({
    url: '/euFarmerInfo/listStockInherited',
    data
  })
}